import { post } from './axiosInstance';

export const logoutUser = async () => {
    try {
        await post('/api/Auth/Logout', {});
    } catch {
        // Proceed with local logout even if the server call fails
    }
};

export const getUserToken = async (username, password, forceLogin = false) => {
  const siteId = process.env.REACT_APP_SITE_ID;
  const requestConfig =
    siteId != null && siteId !== ''
      ? { headers: { 'X-Site-Id': String(siteId) } }
      : {};

  let result = {
    isSuccess: false,
    sessionConflict: false,
    data: null
  };

  try {
    const response = await post(
      "/api/Auth/Login",
      { username, password, forceLogin },
      requestConfig
    );

    result.isSuccess = true;
    result.data = response;

  } catch (error) {
    if (error.response?.status === 409) {
      result.sessionConflict = true;
    } else {
      console.error("Login failed:", error.response?.data || error.message);
      result.data = error.response?.data || { message: "An error occurred" };
    }
  }

  return result;
};
